/* eslint-disable no-restricted-syntax */

import dayjs from 'dayjs';
import { TIME_FORMAT_UTC_OFFSET_TIMEZONE, DATE_FORMAT_DASH } from '../dates';

class CSVDailyConsumptionStrategy {
  constructor(metric) {
    this.massRatio = metric ? 0.001 : 0.00220462;
    this.massUnit = metric ? 'kg' : 'lbs';
    this.timeZoneString = dayjs.tz().format(TIME_FORMAT_UTC_OFFSET_TIMEZONE);
    this.csvLines = [];
    this.roomNames = [];
    this.feedlineNames = [];
  }

  setFarmObjects = (farms) => {
    // Not needed for columnar format, but keeping for interface compatibility
  };

  processDailyConsumption = (data) => {
    const { columnarData, roomNames, feedlineNames } = data;
    this.roomNames = roomNames;
    this.feedlineNames = feedlineNames;

    // Build header row
    const header = [
      `Date (${this.timeZoneString})`,
      'Barn Name',
      `Barn (${this.massUnit})`,
      `Barn Per Animal (${this.massUnit})`,
    ];

    // Add room columns (name and per animal for each room)
    roomNames.forEach((roomName) => {
      header.push(`RM: ${roomName} (${this.massUnit})`);
      header.push(`RM: ${roomName} Per Animal (${this.massUnit})`);
    });

    // Add feedline columns (only total consumption, no per-animal)
    feedlineNames.forEach((feedlineName) => {
      header.push(`FL: ${feedlineName} (${this.massUnit})`);
    });

    this.csvLines.push(header.join(', '));

    // Build data rows
    columnarData.forEach((rowData) => {
      const dateStr = dayjs.tz(rowData.date * 1000).format(DATE_FORMAT_DASH);
      const row = [
        dateStr,
        rowData.barnName || '',
        rowData.wholeBarn != null ? rowData.wholeBarn * this.massRatio : '',
        rowData.wholeBarnPerAnimal != null ? rowData.wholeBarnPerAnimal * this.massRatio : '',
      ];

      // Add room data
      rowData.rooms.forEach((room) => {
        row.push(room.total != null ? room.total * this.massRatio : '');
        row.push(room.perAnimal != null ? room.perAnimal * this.massRatio : '');
      });

      // Add feedline data (only total consumption)
      rowData.feedlines.forEach((feedline) => {
        row.push(feedline.total != null ? feedline.total * this.massRatio : '');
      });

      this.csvLines.push(row.join(', '));
    });
  };

  createFile = () => {
    const toWrite = this.csvLines.join('\n');
    this.csvLines = null;
    return new Blob([toWrite], { type: 'text/csv' });
  };
}

export default CSVDailyConsumptionStrategy;


